import React from 'react';
import Popover from '../Popover';

export default ({ children, ...props }) => {
  if (children.filter(c => Boolean(c)).length <= 1) {
    return null;
  }
  return <Popover {...props}>{children}</Popover>;
};
